import React from "react";
import CatalogoSimple from "../CatalogoSimple";

// Agentes aduanales: se eligen en la revalidación del contenedor
export default function ListadoAgentesAduanales() {
  return (
    <CatalogoSimple
      titulo="Agentes aduanales"
      subtitulo="Opciones que se eligen en la revalidación del contenedor"
      icono="fas fa-user-tie"
      url={process.env.REACT_APP_URL_AGENTES_ADUANALES}
    />
  );
}
